import { getApiClient as f, useTenant as b, requireTenantId as g, clientKeys as $e, issuersApi as He, buildSearchWhere as Ve, SystemBadge as je, SearchInput as Je, ConfirmDialog as Se, LoadingSpinner as me, ApiErrorDisplay as pe, EmptyState as Fe, useColorScheme as We, TemplateVariablesTable as Ge, HtmlPreviewDialog as Ye, useClientByClientId as Xe } from "@authifi/clique-react-ui";
import { issuersApi as rn } from "@authifi/clique-react-ui";
import { useQueryClient as Q, useMutation as U, useQuery as H, keepPreviousData as Ze } from "@tanstack/react-query";
import { jsx as s, jsxs as p, Fragment as he } from "react/jsx-runtime";
import { useState as $, useMemo as X, useCallback as w, useEffect as le, useRef as fe } from "react";
import { DataTable as et } from "primereact/datatable";
import { Column as ue } from "primereact/column";
import { Button as K } from "primereact/button";
import { Dialog as Ce } from "primereact/dialog";
import { InputText as qe } from "primereact/inputtext";
import { Panel as tt } from "primereact/panel";
import { Toast as Ae } from "primereact/toast";
import nt from "@monaco-editor/react";
import { Dropdown as at } from "primereact/dropdown";
import { Checkbox as it } from "primereact/checkbox";
import { ProgressSpinner as rt } from "primereact/progressspinner";
import { confirmDialog as st, ConfirmDialog as ot } from "primereact/confirmdialog";
function Y(e) {
  return `/auth/admin/tenants/${e}`;
}
const te = {
  list(e, t) {
    return f().get(`${Y(e)}/html-templates`, {
      params: t ? { filter: JSON.stringify(t) } : void 0
    });
  },
  getById(e, t) {
    return f().get(`${Y(e)}/html-template/${t}`);
  },
  create(e, t) {
    return f().post(`${Y(e)}/html-template`, t);
  },
  update(e, t, n) {
    return f().put(`${Y(e)}/html-template/${t}`, n);
  },
  delete(e, t) {
    return f().delete(`${Y(e)}/html-templates/${t}`);
  },
  getDefault(e, t) {
    return f().get(
      `${Y(e)}/html-templates/default/${t}`
    );
  },
  getVariables(e, t) {
    return f().get(
      `${Y(e)}/html-template-variables/${t}`
    );
  },
  revertToDefault(e) {
    return f().post(`/html-templates/${e}/revert-to-system-default`);
  },
  listHistory(e, t) {
    return f().get(
      `${Y(e)}/html-template-history`,
      {
        params: t ? { filter: JSON.stringify(t) } : void 0
      }
    );
  },
  getHistoryById(e, t) {
    return f().get(
      `${Y(e)}/html-template-history/${t}`
    );
  }
};
function se(e) {
  return `/auth/admin/tenants/${e}`;
}
const ge = {
  list(e, t) {
    return f().get(`${se(e)}/login-pages`, {
      params: t ? { filter: JSON.stringify(t) } : void 0
    });
  },
  getById(e, t) {
    return f().get(`${se(e)}/login-pages/${t}`);
  },
  create(e, t) {
    return f().post(`${se(e)}/login-pages`, t);
  },
  updateById(e, t, n) {
    return f().patch(`${se(e)}/login-pages/${t}`, n);
  },
  replaceById(e, t, n) {
    return f().put(`${se(e)}/login-pages/${t}`, n);
  },
  updateDraftById(e, t, n) {
    return f().patch(`${se(e)}/draft-login-pages/${t}`, n);
  }
};
function oe(e) {
  return `/auth/admin/tenants/${e}`;
}
const ye = {
  list(e, t, n) {
    const i = {
      ...n,
      where: { ...n == null ? void 0 : n.where, clientId: t }
    };
    return f().get(`${oe(e)}/client-login-pages`, {
      params: { filter: JSON.stringify(i) }
    });
  },
  getById(e, t) {
    return f().get(`${oe(e)}/client-login-pages/${t}`);
  },
  create(e, t) {
    return f().post(`${oe(e)}/client-login-pages`, t);
  },
  updateById(e, t, n) {
    return f().patch(`${oe(e)}/client-login-pages/${t}`, n);
  },
  replaceById(e, t, n) {
    return f().put(`${oe(e)}/client-login-pages/${t}`, n);
  },
  updateDraftById(e, t, n) {
    return f().patch(`${oe(e)}/draft-login-pages/${t}`, n);
  }
}, ve = {
  listByTenant(e, t) {
    return f().get(`/auth/admin/tenants/${e}/providers`, {
      params: t ? { filter: JSON.stringify(t) } : void 0
    });
  },
  listByClient(e, t, n) {
    return f().get(
      `/auth/admin/tenants/${e}/clients/${t}/providers`,
      { params: n ? { filter: JSON.stringify(n) } : void 0 }
    );
  },
  assignToClient(e, t, n) {
    return f().put(
      `/auth/admin/tenants/${e}/providers/${t}/clients/rel/${n}`
    );
  },
  unassignFromClient(e, t, n) {
    return f().delete(
      `/auth/admin/tenants/${e}/providers/${t}/clients/rel/${n}`
    );
  }
}, k = {
  all: (e) => ["loginTemplates", e],
  list: (e, t) => [...k.all(e), "list", t],
  detail: (e, t) => [...k.all(e), "detail", t],
  variables: (e, t) => [...k.all(e), "variables", t],
  defaultTemplate: (e, t) => [...k.all(e), "default", t],
  history: (e) => ["loginTemplateHistory", e]
};
function Le(e) {
  const { numericTenantId: t } = b(), n = {
    ...e,
    where: { ...e == null ? void 0 : e.where, type: "login" }
  };
  return H({
    queryKey: k.list(t, n),
    queryFn: () => te.list(g(t), n).then((i) => i.data),
    enabled: t !== null,
    placeholderData: Ze
  });
}
function Ht(e) {
  const { numericTenantId: t } = b();
  return H({
    queryKey: k.detail(t, e),
    queryFn: () => te.getById(g(t), e).then((n) => n.data),
    enabled: t !== null && e > 0
  });
}
function lt(e = "login") {
  const { numericTenantId: t } = b();
  return H({
    queryKey: k.variables(t, e),
    queryFn: () => te.getVariables(g(t), e).then((n) => n.data),
    enabled: t !== null
  });
}
function Vt(e = "login") {
  const { numericTenantId: t } = b();
  return H({
    queryKey: k.defaultTemplate(t, e),
    queryFn: () => te.getDefault(g(t), e).then((n) => n.data),
    enabled: t !== null
  });
}
function dt(e) {
  const { numericTenantId: t } = b(), n = {
    where: { templateId: e }
  };
  return H({
    queryKey: k.history(e),
    queryFn: () => te.listHistory(g(t), n).then(
      (i) => [...i.data].sort(
        (r, a) => new Date(a.entity.updatedAt).getTime() - new Date(r.entity.updatedAt).getTime()
      )
    ),
    enabled: t !== null && e > 0
  });
}
function ct() {
  const { numericTenantId: e } = b(), t = Q();
  return U({
    onMutate: () => ({ tenantId: g(e) }),
    mutationFn: (n) => {
      const i = g(e);
      return te.create(i, {
        ...n,
        type: n.type ?? "login",
        tenantId: i,
        isSystemTemplate: !1
      }).then((r) => r.data);
    },
    onSuccess: (n, i, r) => {
      t.invalidateQueries({ queryKey: k.all(r.tenantId) });
    }
  });
}
function ut() {
  const { numericTenantId: e } = b(), t = Q();
  return U({
    onMutate: () => ({ tenantId: g(e) }),
    mutationFn: ({
      id: n,
      data: i
    }) => {
      const r = g(e);
      return te.update(r, n, {
        ...i,
        id: n,
        type: i.type ?? "login",
        tenantId: r,
        isSystemTemplate: !1
      }).then((a) => a.data);
    },
    onSuccess: (n, { id: i }, r) => {
      t.invalidateQueries({ queryKey: k.all(r.tenantId) }), t.invalidateQueries({
        queryKey: k.detail(r.tenantId, i)
      });
    }
  });
}
function mt() {
  const { numericTenantId: e } = b(), t = Q();
  return U({
    onMutate: () => ({ tenantId: g(e) }),
    mutationFn: (n) => {
      const i = g(e);
      return te.delete(i, n);
    },
    onSuccess: (n, i, r) => {
      t.invalidateQueries({ queryKey: k.all(r.tenantId) });
    }
  });
}
function pt() {
  const { numericTenantId: e } = b(), t = Q();
  return U({
    onMutate: () => ({ tenantId: g(e) }),
    mutationFn: (n) => te.revertToDefault(n).then((i) => i.data),
    onSuccess: (n, i, r) => {
      t.invalidateQueries({ queryKey: k.all(r.tenantId) }), t.invalidateQueries({
        queryKey: k.detail(r.tenantId, i)
      });
    }
  });
}
const Z = {
  all: (e) => ["tenantLoginPages", e],
  list: (e, t) => [...Z.all(e), "list", t],
  detail: (e, t) => [...Z.all(e), "detail", t]
};
function Me(e) {
  const { numericTenantId: t } = b();
  return H({
    queryKey: Z.list(t, e),
    queryFn: () => ge.list(g(t), e).then((n) => n.data),
    enabled: t !== null
  });
}
function jt(e) {
  const { numericTenantId: t } = b();
  return H({
    queryKey: Z.detail(t, e),
    queryFn: () => ge.getById(g(t), e).then((n) => n.data),
    enabled: t !== null && e > 0
  });
}
function Jt() {
  const { numericTenantId: e } = b(), t = Q();
  return U({
    onMutate: () => ({ tenantId: g(e) }),
    mutationFn: (n) => {
      const i = g(e);
      return ge.create(i, { ...n, tenantId: i }).then((r) => r.data);
    },
    onSuccess: (n, i, r) => {
      t.invalidateQueries({ queryKey: Z.all(r.tenantId) });
    }
  });
}
function Wt() {
  const { numericTenantId: e } = b(), t = Q();
  return U({
    onMutate: () => ({ tenantId: g(e) }),
    mutationFn: ({ id: n, data: i }) => {
      const r = g(e);
      return ge.updateById(r, n, i);
    },
    onSuccess: (n, { id: i }, r) => {
      t.invalidateQueries({ queryKey: Z.all(r.tenantId) }), t.invalidateQueries({
        queryKey: Z.detail(r.tenantId, i)
      });
    }
  });
}
function Ke() {
  const { numericTenantId: e } = b(), t = Q();
  return U({
    onMutate: () => ({ tenantId: g(e) }),
    mutationFn: ({ id: n, draftConfig: i }) => {
      const r = g(e), a = { draftConfig: i };
      return ge.updateDraftById(r, n, a);
    },
    onSuccess: (n, { id: i }, r) => {
      t.invalidateQueries({ queryKey: Z.all(r.tenantId) }), t.invalidateQueries({
        queryKey: Z.detail(r.tenantId, i)
      });
    }
  });
}
const ee = {
  all: (e, t) => ["clientLoginPages", e, t],
  list: (e, t, n) => [...ee.all(e, t), "list", n],
  detail: (e, t, n) => [...ee.all(e, t), "detail", n]
};
function Gt(e, t) {
  const { numericTenantId: n } = b();
  return H({
    queryKey: ee.list(n, e, t),
    queryFn: () => ye.list(g(n), e, t).then((i) => i.data),
    enabled: n !== null && e !== void 0
  });
}
function Yt(e, t) {
  const { numericTenantId: n } = b();
  return H({
    queryKey: ee.detail(n, e, t),
    queryFn: () => ye.getById(g(n), t).then((i) => i.data),
    enabled: n !== null && e !== void 0 && t > 0
  });
}
function gt(e) {
  const { numericTenantId: t } = b(), n = Q();
  return U({
    onMutate: () => ({
      tenantId: g(t),
      clientId: e
    }),
    mutationFn: (i) => {
      const r = g(t);
      return ye.create(r, { ...i, clientId: e }).then((a) => a.data);
    },
    onSuccess: (i, r, a) => {
      n.invalidateQueries({
        queryKey: ee.all(a.tenantId, a.clientId)
      }), n.invalidateQueries({
        queryKey: $e.all(a.tenantId)
      });
    }
  });
}
function yt(e) {
  const { numericTenantId: t } = b(), n = Q();
  return U({
    onMutate: () => ({
      tenantId: g(t),
      clientId: e
    }),
    mutationFn: ({ id: i, data: r }) => {
      const a = g(t);
      return ye.updateById(a, i, r);
    },
    onSuccess: (i, { id: r }, a) => {
      n.invalidateQueries({
        queryKey: ee.all(a.tenantId, a.clientId)
      }), n.invalidateQueries({
        queryKey: ee.detail(a.tenantId, a.clientId, r)
      }), n.invalidateQueries({
        queryKey: $e.all(a.tenantId)
      });
    }
  });
}
function Xt(e) {
  const { numericTenantId: t } = b(), n = Q();
  return U({
    onMutate: () => ({
      tenantId: g(t),
      clientId: e
    }),
    mutationFn: ({ id: i, draftConfig: r }) => {
      const a = g(t), o = { draftConfig: r };
      return ye.updateDraftById(a, i, o);
    },
    onSuccess: (i, { id: r }, a) => {
      n.invalidateQueries({
        queryKey: ee.all(a.tenantId, a.clientId)
      }), n.invalidateQueries({
        queryKey: ee.detail(a.tenantId, a.clientId, r)
      });
    }
  });
}
const de = {
  all: (e) => ["identityProviders", e],
  byTenant: (e, t) => [...de.all(e), "byTenant", t],
  byClient: (e, t, n) => [...de.all(e), "byClient", t, n]
};
function ke(e) {
  const { numericTenantId: t } = b();
  return H({
    queryKey: de.byTenant(t, e),
    queryFn: () => ve.listByTenant(g(t), e).then((n) => n.data),
    enabled: t !== null
  });
}
function Oe(e, t) {
  const { numericTenantId: n } = b();
  return H({
    queryKey: de.byClient(n, e, t),
    queryFn: () => ve.listByClient(g(n), e, t).then((i) => i.data),
    enabled: n !== null && e !== void 0
  });
}
function _e(e) {
  const { numericTenantId: t } = b(), n = Q();
  return U({
    onMutate: () => ({
      tenantId: g(t),
      clientId: e
    }),
    mutationFn: (i) => {
      const r = g(t);
      return ve.assignToClient(r, i, e);
    },
    onSuccess: (i, r, a) => {
      n.invalidateQueries({
        queryKey: de.byClient(a.tenantId, a.clientId)
      });
    }
  });
}
function Re(e) {
  const { numericTenantId: t } = b(), n = Q();
  return U({
    onMutate: () => ({
      tenantId: g(t),
      clientId: e
    }),
    mutationFn: (i) => {
      const r = g(t);
      return ve.unassignFromClient(r, i, e);
    },
    onSuccess: (i, r, a) => {
      n.invalidateQueries({
        queryKey: de.byClient(a.tenantId, a.clientId)
      });
    }
  });
}
const Be = {
  all: ["issuers"],
  byId: (e) => [...Be.all, e]
};
function ze(e) {
  return H({
    queryKey: Be.byId(e),
    queryFn: () => He.getById(e).then((t) => t.data),
    enabled: e != null,
    staleTime: 300 * 1e3
  });
}
function ht(e) {
  const { onSuccess: t, onError: n } = e ?? {}, [i, r] = $(""), [a, o] = $(null), [d, m] = $(null), c = X(() => {
    const A = Ve(["name"], i);
    return A ? { where: A } : void 0;
  }, [i]), { data: l, isLoading: y, isError: u, error: L, refetch: O } = Le(c), V = mt(), F = pt(), q = w(() => {
    a && V.mutate(a.id, {
      onSuccess: () => {
        t == null || t(`Template "${a.name}" deleted successfully.`), o(null);
      },
      onError: (A) => {
        console.error("Failed to delete template", A), n == null || n("Failed to delete template. Please try again."), o(null);
      }
    });
  }, [a, V, t, n]), _ = w(() => {
    d && F.mutate(d.id, {
      onSuccess: () => {
        t == null || t(`Template "${d.name}" reverted to system default.`), m(null);
      },
      onError: (A) => {
        console.error("Failed to revert template", A), n == null || n("Failed to revert template. Please try again."), m(null);
      }
    });
  }, [d, F, t, n]), T = (l == null ? void 0 : l.length) === 0 && !i, N = (l == null ? void 0 : l.length) === 0 && !!i;
  return {
    templates: l,
    search: i,
    setSearch: r,
    isLoading: y,
    isError: u,
    error: L,
    refetch: () => void O(),
    isEmpty: T,
    isEmptySearch: N,
    deleteTarget: a,
    setDeleteTarget: o,
    handleDelete: q,
    isDeleting: V.isPending,
    revertTarget: d,
    setRevertTarget: m,
    handleRevert: _,
    isReverting: F.isPending,
    filter: c
  };
}
function Zt({ onTemplateSelect: e, onCreateTemplate: t }) {
  var d, m;
  const n = ht(), i = w(
    (c) => /* @__PURE__ */ s(je, { isSystem: c.isSystemTemplate }),
    []
  ), r = w(
    (c) => /* @__PURE__ */ s("span", { className: "text-[var(--clique-fg-secondary)] text-sm", children: new Date(c.updatedAt).toLocaleDateString() }),
    []
  ), a = w(
    (c) => /* @__PURE__ */ p("div", { className: "flex gap-1", children: [
      /* @__PURE__ */ s(
        K,
        {
          type: "button",
          icon: "pi pi-pencil",
          severity: "secondary",
          text: !0,
          size: "small",
          tooltip: "Edit",
          tooltipOptions: { position: "top" },
          onClick: (l) => {
            l.stopPropagation(), e == null || e(c);
          }
        }
      ),
      !c.isSystemTemplate && /* @__PURE__ */ p(he, { children: [
        /* @__PURE__ */ s(
          K,
          {
            type: "button",
            icon: "pi pi-undo",
            severity: "secondary",
            text: !0,
            size: "small",
            tooltip: "Revert to Default",
            tooltipOptions: { position: "top" },
            onClick: (l) => {
              l.stopPropagation(), n.setRevertTarget(c);
            }
          }
        ),
        /* @__PURE__ */ s(
          K,
          {
            type: "button",
            icon: "pi pi-trash",
            severity: "danger",
            text: !0,
            size: "small",
            tooltip: "Delete",
            tooltipOptions: { position: "top" },
            onClick: (l) => {
              l.stopPropagation(), n.setDeleteTarget(c);
            }
          }
        )
      ] })
    ] }),
    [e, n]
  ), o = () => n.isLoading && !n.templates ? /* @__PURE__ */ s(me, { message: "Loading templates..." }) : n.isError ? /* @__PURE__ */ s(
    pe,
    {
      error: n.error,
      resourceLabel: "login templates",
      onRetry: n.refetch
    }
  ) : n.isEmpty ? /* @__PURE__ */ s(
    Fe,
    {
      icon: "pi pi-file-edit",
      title: "No login templates yet",
      message: "Create a login template to customize the login experience.",
      actionLabel: t ? "Create Template" : void 0,
      onAction: t
    }
  ) : /* @__PURE__ */ p(
    et,
    {
      value: n.templates ?? [],
      loading: n.isLoading,
      dataKey: "id",
      emptyMessage: "No templates match your search.",
      selectionMode: "single",
      onSelectionChange: (c) => {
        c.value && (e == null || e(c.value));
      },
      rowHover: !0,
      stripedRows: !0,
      className: "rounded-lg border border-[var(--clique-border)] overflow-hidden",
      rowClassName: () => e ? "cursor-pointer" : "",
      children: [
        /* @__PURE__ */ s(ue, { field: "name", header: "Name", sortable: !0, className: "font-medium" }),
        /* @__PURE__ */ s(
          ue,
          {
            field: "description",
            header: "Description",
            body: (c) => /* @__PURE__ */ s("span", { className: "text-[var(--clique-fg-secondary)]", children: c.description || "—" })
          }
        ),
        /* @__PURE__ */ s(ue, { header: "Type", body: i, style: { width: "120px" } }),
        /* @__PURE__ */ s(ue, { header: "Updated", body: r, style: { width: "120px" } }),
        /* @__PURE__ */ s(ue, { header: "Actions", body: a, style: { width: "140px" } })
      ]
    }
  );
  return /* @__PURE__ */ p("div", { children: [
    /* @__PURE__ */ p("div", { className: "flex items-center justify-between mb-4 gap-4", children: [
      /* @__PURE__ */ s(
        Je,
        {
          value: n.search,
          onChange: n.setSearch,
          placeholder: "Search templates by name...",
          className: "flex-1 max-w-md"
        }
      ),
      t && /* @__PURE__ */ s(K, { label: "New Template", icon: "pi pi-plus", onClick: t, size: "small" })
    ] }),
    o(),
    /* @__PURE__ */ s(
      Se,
      {
        visible: n.deleteTarget !== null,
        onHide: () => n.setDeleteTarget(null),
        onConfirm: n.handleDelete,
        header: "Delete Template",
        message: `Are you sure you want to delete "${(d = n.deleteTarget) == null ? void 0 : d.name}"? This action cannot be undone.`,
        confirmLabel: "Delete",
        confirmIcon: "pi pi-trash",
        confirmSeverity: "danger",
        loading: n.isDeleting
      }
    ),
    /* @__PURE__ */ s(
      Se,
      {
        visible: n.revertTarget !== null,
        onHide: () => n.setRevertTarget(null),
        onConfirm: n.handleRevert,
        header: "Revert to System Default",
        message: `Are you sure you want to revert "${(m = n.revertTarget) == null ? void 0 : m.name}" to the system default? Your customizations will be lost.`,
        confirmLabel: "Revert",
        confirmIcon: "pi pi-undo",
        confirmSeverity: "warning",
        loading: n.isReverting
      }
    )
  ] });
}
function Qe({
  value: e,
  onChange: t,
  readOnly: n = !1,
  height: i = "300px"
}) {
  const r = We() === "dark", a = w(
    (o) => {
      t == null || t(o ?? "");
    },
    [t]
  );
  return /* @__PURE__ */ s("div", { className: "border border-[var(--clique-border)] rounded-lg overflow-hidden", children: /* @__PURE__ */ s(
    nt,
    {
      height: i,
      defaultLanguage: "html",
      value: e,
      onChange: a,
      theme: r ? "vs-dark" : "light",
      options: {
        readOnly: n,
        minimap: { enabled: !1 },
        wordWrap: "on",
        scrollBeyondLastLine: !1,
        lineNumbers: "on",
        fontSize: 13,
        tabSize: 2,
        automaticLayout: !0
      }
    }
  ) });
}
function ft({ type: e = "login" }) {
  const { data: t, isLoading: n, isError: i, error: r, refetch: a } = lt(e);
  return /* @__PURE__ */ s(
    Ge,
    {
      variables: t,
      isLoading: n,
      isError: i,
      error: r,
      onRetry: () => void a()
    }
  );
}
function Ue({ visible: e, onHide: t, previewUrl: n }) {
  return /* @__PURE__ */ s(
    Ye,
    {
      visible: e,
      onHide: t,
      header: "Login Page Preview",
      src: n,
      width: "80rem",
      height: "90vh",
      sandbox: "allow-same-origin allow-scripts allow-forms"
    }
  );
}
const Pe = {
  name: "",
  description: "",
  template: ""
};
function vt(e) {
  const {
    visible: t,
    templateId: n,
    previewBaseUrl: i,
    clientId: r,
    previewMode: a = "window",
    onSaved: o,
    onHide: d,
    onPreviewError: m
  } = e, c = n != null && n > 0, { tenantId: l } = b(), [y, u] = $(Pe), [L, O] = $(""), [V, F] = $(""), [q, _] = $(""), [T, N] = $(!1), [A, j] = $(!1), {
    data: P,
    isLoading: ne,
    isError: J,
    error: W,
    refetch: D
  } = Le(), h = X(
    () => c ? P == null ? void 0 : P.find((I) => I.id === n) : void 0,
    [c, P, n]
  ), C = c && !ne && !J && P != null && h == null, z = J || C, R = ct(), v = ut(), { data: S } = Me(), E = Ke(), M = S == null ? void 0 : S[0], ae = R.isPending || v.isPending, G = (h == null ? void 0 : h.isSystemTemplate) === !0, ie = c && G, re = X(() => {
    if (!i || !l) return "";
    const I = new URLSearchParams({
      tenant: l,
      is_tenant_login: "true"
    });
    return r && I.set("client", r), `${i}/auth/draftLogin?${I.toString()}`;
  }, [i, l, r]), be = !!i && !!M && y.template.trim().length > 0, Ie = w(() => {
    !M || !y.template.trim() || E.mutate(
      {
        id: M.id,
        draftConfig: {
          ...M.draftConfig,
          page: y.template
        }
      },
      {
        onSuccess: () => {
          re && (a === "dialog" ? j(!0) : window.open(re, "login-preview", "width=1024,height=768,scrollbars=yes"));
        },
        onError: () => {
          m == null || m("Failed to prepare preview. Please try again.");
        }
      }
    );
  }, [M, y.template, E, re, a, m]);
  le(() => {
    t && (c ? N(!1) : (u(Pe), N(!0)), O(""), F(""), _(""));
  }, [t, c]), le(() => {
    c && h && !T && (u({
      name: h.name,
      description: h.description ?? "",
      template: h.template ?? ""
    }), N(!0));
  }, [c, h, T]);
  const we = w(
    (I, B) => {
      u((Ne) => ({ ...Ne, [I]: B })), I === "name" && O(""), I === "template" && F("");
    },
    []
  ), Te = w(() => {
    u(Pe), O(""), F(""), _(""), N(!1);
  }, []), ce = w(() => {
    let I = !0;
    return y.name.trim() ? O("") : (O("Name is required."), I = !1), y.template.trim() ? F("") : (F("HTML template is required."), I = !1), I;
  }, [y.name, y.template]), x = w(() => {
    if (ce())
      if (_(""), c) {
        const I = {
          name: y.name.trim(),
          description: y.description.trim() || void 0,
          template: y.template
        };
        v.mutate(
          { id: n, data: I },
          {
            onSuccess: (B) => {
              o == null || o(B), d == null || d();
            },
            onError: (B) => {
              console.error("Failed to update template", B), _("Failed to update template. Please try again.");
            }
          }
        );
      } else {
        const I = {
          name: y.name.trim(),
          description: y.description.trim() || void 0,
          template: y.template
        };
        R.mutate(I, {
          onSuccess: (B) => {
            o == null || o(B), d == null || d();
          },
          onError: (B) => {
            console.error("Failed to create template", B), _("Failed to create template. Please try again.");
          }
        });
      }
  }, [y, ce, c, n, R, v, o, d]);
  return {
    form: y,
    updateField: we,
    resetForm: Te,
    formInitialized: T,
    isEditMode: c,
    isReadOnly: ie,
    isSystemTemplate: G,
    existingTemplate: h,
    isLoading: ne,
    isError: z,
    fetchError: W,
    refetch: () => void D(),
    nameError: L,
    templateError: V,
    submitError: q,
    handleSubmit: x,
    isPending: ae,
    canPreview: be,
    previewUrl: re,
    showPreview: A,
    setShowPreview: j,
    handlePreview: Ie,
    isPreviewPending: E.isPending
  };
}
function bt({
  visible: e,
  onHide: t,
  templateId: n,
  onSaved: i,
  onHistoryClick: r,
  previewBaseUrl: a,
  clientId: o,
  previewMode: d = "window"
}) {
  const m = fe(null), c = fe(null), l = vt({
    visible: e,
    templateId: n,
    previewBaseUrl: a,
    clientId: o,
    previewMode: d,
    onSaved: i,
    onHide: t,
    onPreviewError: (u) => {
      var L;
      (L = c.current) == null || L.show({
        severity: "error",
        summary: "Error",
        detail: u,
        life: 5e3
      });
    }
  });
  le(() => {
    e && l.formInitialized && !l.isEditMode && setTimeout(() => {
      var u;
      return (u = m.current) == null ? void 0 : u.focus();
    }, 100);
  }, [e, l.formInitialized, l.isEditMode]);
  const y = /* @__PURE__ */ p("div", { className: "flex items-center justify-between w-full", children: [
    /* @__PURE__ */ s("span", { children: "HTML Template" }),
    /* @__PURE__ */ p("div", { className: "flex items-center gap-2", children: [
      l.canPreview && /* @__PURE__ */ s(
        K,
        {
          type: "button",
          label: "Preview",
          icon: "pi pi-eye",
          className: "p-button-text p-button-sm",
          onClick: l.handlePreview,
          loading: l.isPreviewPending,
          disabled: l.isPending
        }
      ),
      l.isEditMode && l.existingTemplate && /* @__PURE__ */ s(
        K,
        {
          type: "button",
          label: "History",
          icon: "pi pi-history",
          className: "p-button-text p-button-sm",
          onClick: () => r == null ? void 0 : r(n)
        }
      )
    ] })
  ] });
  return /* @__PURE__ */ p(
    Ce,
    {
      visible: e,
      onHide: t,
      header: y,
      modal: !0,
      draggable: !1,
      resizable: !1,
      closable: !l.isPending,
      closeOnEscape: !l.isPending,
      maximizable: !0,
      style: { width: "60rem" },
      breakpoints: { "960px": "95vw" },
      footer: !l.isReadOnly && /* @__PURE__ */ p("div", { className: "flex justify-end gap-3", children: [
        /* @__PURE__ */ s(
          K,
          {
            type: "button",
            label: "Cancel",
            onClick: t,
            severity: "secondary",
            outlined: !0,
            disabled: l.isPending
          }
        ),
        /* @__PURE__ */ s(
          K,
          {
            type: "button",
            label: l.isEditMode ? "Save" : "Create",
            icon: "pi pi-check",
            onClick: l.handleSubmit,
            raised: !0,
            loading: l.isPending
          }
        )
      ] }),
      children: [
        /* @__PURE__ */ s(Ae, { ref: c }),
        l.isEditMode && l.isLoading && /* @__PURE__ */ s(me, { message: "Loading template..." }),
        l.isEditMode && l.isError && /* @__PURE__ */ s(
          pe,
          {
            error: l.fetchError,
            resourceLabel: "template",
            onRetry: l.refetch
          }
        ),
        (!l.isEditMode || l.formInitialized && !l.isLoading && !l.isError) && /* @__PURE__ */ p("div", { className: "flex flex-col gap-5", children: [
          l.isReadOnly && /* @__PURE__ */ p("div", { className: "bg-[var(--clique-warning-subtle)] border border-[var(--clique-warning-border)] rounded-lg p-3 text-sm text-[var(--clique-warning-strong)]", children: [
            /* @__PURE__ */ s("i", { "aria-hidden": "true", className: "pi pi-info-circle mr-2" }),
            "System Template - Read Only"
          ] }),
          /* @__PURE__ */ p("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ p(
              "label",
              {
                htmlFor: "template-name",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: [
                  "Name ",
                  /* @__PURE__ */ s("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                ]
              }
            ),
            /* @__PURE__ */ s(
              qe,
              {
                id: "template-name",
                ref: m,
                value: l.form.name,
                onChange: (u) => l.updateField("name", u.target.value),
                placeholder: "Enter template name",
                className: `w-full ${l.nameError ? "p-invalid" : ""}`,
                "aria-invalid": !!l.nameError,
                "aria-describedby": l.nameError ? "template-name-error" : void 0,
                disabled: l.isReadOnly
              }
            ),
            l.nameError && /* @__PURE__ */ s("small", { id: "template-name-error", className: "text-[var(--clique-destructive)] text-xs", children: l.nameError })
          ] }),
          /* @__PURE__ */ p("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ s(
              "label",
              {
                htmlFor: "template-description",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: "Description"
              }
            ),
            /* @__PURE__ */ s(
              qe,
              {
                id: "template-description",
                value: l.form.description,
                onChange: (u) => l.updateField("description", u.target.value),
                placeholder: "Enter template description",
                className: "w-full",
                disabled: l.isReadOnly
              }
            )
          ] }),
          /* @__PURE__ */ p("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ p("label", { className: "text-sm font-semibold text-[var(--clique-fg)]", children: [
              "HTML Template ",
              /* @__PURE__ */ s("span", { className: "text-[var(--clique-destructive)]", children: "*" })
            ] }),
            /* @__PURE__ */ s(
              Qe,
              {
                value: l.form.template,
                onChange: (u) => l.updateField("template", u),
                readOnly: l.isReadOnly,
                height: "350px"
              }
            ),
            l.templateError && /* @__PURE__ */ s("small", { className: "text-[var(--clique-destructive)] text-xs", children: l.templateError })
          ] }),
          /* @__PURE__ */ s(tt, { header: "Expansion Variables", toggleable: !0, collapsed: !0, className: "mt-2", children: /* @__PURE__ */ s(ft, {}) }),
          l.submitError && /* @__PURE__ */ p("div", { className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3", children: [
            /* @__PURE__ */ s("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
            l.submitError
          ] })
        ] }),
        d === "dialog" && /* @__PURE__ */ s(
          Ue,
          {
            visible: l.showPreview,
            onHide: () => l.setShowPreview(!1),
            previewUrl: l.previewUrl
          }
        )
      ]
    }
  );
}
function It({
  visible: e,
  onHide: t,
  templateId: n
}) {
  const [i, r] = $(null), { data: a, isLoading: o, isError: d, error: m, refetch: c } = dt(n), l = w(() => {
    r(null), t();
  }, [t]), y = (u) => {
    const L = new Date(u);
    return isNaN(L.getTime()) ? "—" : L.toLocaleString(void 0, {
      month: "numeric",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: !0
    });
  };
  return /* @__PURE__ */ p(
    Ce,
    {
      visible: e,
      onHide: l,
      header: "History",
      modal: !0,
      draggable: !1,
      resizable: !1,
      style: { width: i ? "70rem" : "36rem" },
      breakpoints: { "960px": "95vw" },
      children: [
        o && /* @__PURE__ */ s(me, { message: "Loading history..." }),
        d && /* @__PURE__ */ s(
          pe,
          {
            error: m,
            resourceLabel: "template history",
            onRetry: () => void c()
          }
        ),
        !o && !d && /* @__PURE__ */ s("div", { className: "lth-content", children: a != null && a.length ? /* @__PURE__ */ p(he, { children: [
          /* @__PURE__ */ s("ul", { className: "lth-list", children: a.map((u, L) => /* @__PURE__ */ p(
            "li",
            {
              className: `lth-list-item${L !== a.length - 1 ? " lth-list-item--bordered" : ""}${(i == null ? void 0 : i.id) === u.id ? " lth-list-item--selected" : ""}`,
              children: [
                /* @__PURE__ */ s(
                  "button",
                  {
                    type: "button",
                    className: "lth-date-btn",
                    onClick: () => r(u),
                    children: y(u.entity.updatedAt)
                  }
                ),
                L === 0 && /* @__PURE__ */ s("span", { className: "lth-current-badge", children: "Current" })
              ]
            },
            u.id
          )) }),
          i && /* @__PURE__ */ p("div", { className: "lth-preview", children: [
            /* @__PURE__ */ p("span", { className: "lth-preview__label", children: [
              "Version from ",
              y(i.entity.updatedAt)
            ] }),
            /* @__PURE__ */ s(Qe, { value: i.entity.template, readOnly: !0, height: "300px" })
          ] })
        ] }) : /* @__PURE__ */ s("p", { className: "lth-empty", children: "No history available for this template." }) })
      ]
    }
  );
}
const Ee = {
  enableLoginPageDisplay: !1,
  images: [],
  footerLinks: []
};
function wt(e) {
  var ce;
  const {
    clientId: t,
    previewBaseUrl: n,
    previewMode: i = "window",
    onChange: r,
    onSuccess: a,
    onError: o
  } = e ?? {}, { tenantId: d, numericTenantId: m } = b(), { data: c, isLoading: l } = Xe(t, {
    include: [{ relation: "loginPages" }]
  }), y = c == null ? void 0 : c.id, u = c == null ? void 0 : c.loginPages, [L, O] = $(!1), [V, F] = $(), [q, _] = $(), [T, N] = $(void 0), [A, j] = $(!1), { data: P, isLoading: ne } = Le(), { data: J } = Me(), W = yt(y), D = gt(y), h = Ke(), C = u == null ? void 0 : u[0], z = J == null ? void 0 : J[0], R = ((ce = C == null ? void 0 : C.config) == null ? void 0 : ce.templateId) ?? null, v = T !== void 0, S = v ? T : R;
  le(() => {
    N(void 0);
  }, [R]);
  const E = X(() => P ? P.map((x) => ({ label: x.name, value: x.id })) : [], [P]), M = w((x) => {
    N(x);
  }, []), ae = w(() => {
    N(void 0);
  }, []), G = w(() => {
    if (T === void 0) return;
    const x = P == null ? void 0 : P.find((B) => B.id === T), I = x == null ? void 0 : x.template;
    C ? W.mutate(
      {
        id: C.id,
        data: {
          config: { ...C.config, templateId: T, page: I },
          draftConfig: C.draftConfig
        }
      },
      {
        onSuccess: () => {
          N(void 0), r == null || r(T), a == null || a("Login page template has been updated.");
        },
        onError: () => {
          o == null || o("Failed to update login page template.");
        }
      }
    ) : T != null && m != null && D.mutate(
      {
        config: { ...Ee, templateId: T, page: I },
        draftConfig: { ...Ee, templateId: T, page: I }
      },
      {
        onSuccess: () => {
          N(void 0), r == null || r(T), a == null || a("Login page template has been configured.");
        },
        onError: () => {
          o == null || o("Failed to set login page template.");
        }
      }
    );
  }, [
    T,
    P,
    C,
    m,
    W,
    D,
    r,
    a,
    o
  ]), ie = X(() => {
    if (!n || !d) return "";
    const x = new URLSearchParams({
      tenant: d,
      is_tenant_login: "true"
    });
    return t && x.set("client", t), `${n}/auth/draftLogin?${x.toString()}`;
  }, [n, d, t]), re = S != null && !!n, be = w(() => {
    const x = S;
    if (x == null || !z || !C) return;
    const I = P == null ? void 0 : P.find((B) => B.id === x);
    h.mutate(
      {
        id: z.id,
        draftConfig: {
          ...C.draftConfig,
          templateId: x,
          page: (I == null ? void 0 : I.template) ?? C.draftConfig.page
        }
      },
      {
        onSuccess: () => {
          ie && (i === "dialog" ? j(!0) : window.open(ie, "login-preview", "width=1024,height=768,scrollbars=yes"));
        },
        onError: () => {
          o == null || o("Failed to prepare preview. Please try again.");
        }
      }
    );
  }, [
    S,
    z,
    C,
    P,
    h,
    ie,
    i,
    o
  ]), Ie = w(
    (x) => {
      a == null || a(`"${x.name}" has been saved.`);
    },
    [a]
  ), we = w(() => {
    O(!1), F(void 0);
  }, []), Te = W.isPending || D.isPending || h.isPending;
  return {
    displayedTemplateId: S,
    activeTemplateId: R,
    hasPendingChange: v,
    dropdownOptions: E,
    isLoadingOptions: l || ne,
    handleDropdownChange: M,
    handleCancel: ae,
    handleSave: G,
    isSaving: W.isPending || D.isPending,
    canPreview: re,
    previewUrl: ie,
    showPreview: A,
    setShowPreview: j,
    handlePreview: be,
    isPreviewPending: h.isPending,
    showCreateDialog: L,
    setShowCreateDialog: O,
    editTemplateId: V,
    setEditTemplateId: F,
    historyTemplateId: q,
    setHistoryTemplateId: _,
    handleDialogHide: we,
    handleTemplateSaved: Ie,
    isMutating: Te
  };
}
function en({
  previewBaseUrl: e,
  clientId: t,
  previewMode: n = "window",
  onChange: i
}) {
  const r = fe(null), a = wt({
    clientId: t,
    previewBaseUrl: e,
    previewMode: n,
    onChange: i,
    onSuccess: (o) => {
      var d;
      (d = r.current) == null || d.show({ severity: "success", summary: "Success", detail: o, life: 3e3 });
    },
    onError: (o) => {
      var d;
      (d = r.current) == null || d.show({ severity: "error", summary: "Error", detail: o, life: 5e3 });
    }
  });
  return /* @__PURE__ */ p("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ s(Ae, { ref: r }),
    /* @__PURE__ */ s(
      at,
      {
        value: a.displayedTemplateId,
        options: a.dropdownOptions,
        onChange: (o) => a.handleDropdownChange(o.value),
        placeholder: "No template selected",
        loading: a.isLoadingOptions,
        disabled: a.isMutating,
        className: "w-64"
      }
    ),
    a.hasPendingChange ? /* @__PURE__ */ p(he, { children: [
      /* @__PURE__ */ s(
        K,
        {
          type: "button",
          label: "Save",
          icon: "pi pi-check",
          size: "small",
          disabled: a.isMutating,
          loading: a.isSaving,
          onClick: a.handleSave
        }
      ),
      /* @__PURE__ */ s(
        K,
        {
          type: "button",
          label: "Cancel",
          icon: "pi pi-times",
          severity: "secondary",
          size: "small",
          text: !0,
          disabled: a.isMutating,
          onClick: a.handleCancel
        }
      ),
      /* @__PURE__ */ s(
        K,
        {
          type: "button",
          icon: "pi pi-pencil",
          severity: "secondary",
          text: !0,
          rounded: !0,
          tooltip: "Edit template",
          tooltipOptions: { position: "top" },
          disabled: a.displayedTemplateId == null || a.isMutating,
          onClick: () => a.setEditTemplateId(
            a.displayedTemplateId ?? void 0
          )
        }
      )
    ] }) : /* @__PURE__ */ p(he, { children: [
      /* @__PURE__ */ s(
        K,
        {
          type: "button",
          icon: "pi pi-plus",
          severity: "secondary",
          text: !0,
          rounded: !0,
          tooltip: "Create template",
          tooltipOptions: { position: "top" },
          disabled: a.isMutating,
          onClick: () => a.setShowCreateDialog(!0)
        }
      ),
      /* @__PURE__ */ s(
        K,
        {
          type: "button",
          icon: "pi pi-pencil",
          severity: "secondary",
          text: !0,
          rounded: !0,
          tooltip: "Edit template",
          tooltipOptions: { position: "top" },
          disabled: a.activeTemplateId == null || a.isMutating,
          onClick: () => a.setEditTemplateId(
            a.activeTemplateId ?? void 0
          )
        }
      )
    ] }),
    /* @__PURE__ */ s(
      K,
      {
        type: "button",
        icon: "pi pi-eye",
        severity: "secondary",
        text: !0,
        rounded: !0,
        tooltip: "Preview login page",
        tooltipOptions: { position: "top" },
        disabled: !a.canPreview || a.isMutating,
        onClick: a.handlePreview,
        loading: a.isPreviewPending
      }
    ),
    /* @__PURE__ */ s(
      bt,
      {
        visible: a.showCreateDialog || a.editTemplateId != null,
        onHide: a.handleDialogHide,
        templateId: a.editTemplateId,
        onSaved: a.handleTemplateSaved,
        onHistoryClick: (o) => a.setHistoryTemplateId(o),
        previewBaseUrl: e,
        clientId: t,
        previewMode: n
      }
    ),
    a.historyTemplateId != null && /* @__PURE__ */ s(
      It,
      {
        visible: !0,
        onHide: () => a.setHistoryTemplateId(void 0),
        templateId: a.historyTemplateId
      }
    ),
    n === "dialog" && /* @__PURE__ */ s(
      Ue,
      {
        visible: a.showPreview,
        onHide: () => a.setShowPreview(!1),
        previewUrl: a.previewUrl
      }
    )
  ] });
}
function De(e) {
  return e.displayName || e.name;
}
function xe(e) {
  return e.sortOrder ?? Number.MAX_SAFE_INTEGER;
}
function Tt(e) {
  const { visible: t, clientId: n, onSaved: i, onSuccess: r, onError: a, onHide: o } = e, [d, m] = $(/* @__PURE__ */ new Set()), [c, l] = $(!1), y = fe(n), {
    data: u,
    isLoading: L,
    isError: O,
    error: V,
    refetch: F
  } = ke(), {
    data: q,
    isLoading: _,
    isError: T,
    error: N,
    refetch: A
  } = Oe(n), j = _e(n), P = Re(n), ne = L || _, J = O || T, W = V ?? N;
  le(() => {
    n !== y.current && (y.current = n, m(/* @__PURE__ */ new Set()));
  }, [n]), le(() => {
    t && q && m(new Set(q.map((v) => v.id)));
  }, [t, q]);
  const D = X(() => u ? [...u].sort((v, S) => {
    const E = xe(v) - xe(S);
    return E !== 0 ? E : De(v).localeCompare(De(S));
  }) : [], [u]), h = X(() => {
    if (!q) return !1;
    const v = new Set(q.map((S) => S.id));
    if (v.size !== d.size) return !0;
    for (const S of d)
      if (!v.has(S)) return !0;
    return !1;
  }, [q, d]), C = w((v) => {
    m((S) => {
      const E = new Set(S);
      return E.has(v) ? E.delete(v) : E.add(v), E;
    });
  }, []), z = w(async () => {
    if (!q) return;
    const v = new Set(q.map((M) => M.id)), S = [...d].filter((M) => !v.has(M)), E = [...v].filter((M) => !d.has(M));
    if (S.length === 0 && E.length === 0) {
      o == null || o();
      return;
    }
    l(!0);
    try {
      const ae = (await Promise.allSettled([
        ...S.map((G) => j.mutateAsync(G)),
        ...E.map((G) => P.mutateAsync(G))
      ])).filter((G) => G.status === "rejected");
      ae.length > 0 ? (console.error("Some identity provider assignments failed:", ae), a == null || a("Some provider assignments could not be saved. Please try again.")) : (await A(), i == null || i([...d]), r == null || r("Identity provider assignments updated successfully."), o == null || o());
    } catch {
      a == null || a("Failed to update identity provider assignments. Please try again.");
    } finally {
      l(!1);
    }
  }, [
    q,
    d,
    j,
    P,
    o,
    i,
    r,
    a,
    A
  ]), R = w(() => {
    Promise.all([F(), A()]);
  }, [F, A]);
  return {
    allProviders: u,
    sortedProviders: D,
    selectedIds: d,
    handleToggle: C,
    hasChanges: h,
    isLoading: ne,
    isError: J,
    error: W,
    refetch: R,
    handleSave: () => void z(),
    isSaving: c
  };
}
const Pt = {
  "google-oauth": "Google",
  "azure-oidc": "Azure AD",
  oidc: "OpenID Connect",
  oauth2: "OAuth2",
  saml2: "SAML 2.0",
  wsfed: "WS-Federation",
  "in-common": "InCommon",
  "in-common-direct": "InCommon (Direct)",
  piv: "PIV",
  ldap: "LDAP",
  local: "Local",
  apple: "Apple"
};
function Ct({
  provider: e,
  checked: t,
  disabled: n,
  onToggle: i
}) {
  const r = Pt[e.type] ?? e.type, { data: a } = ze(e.issuerId), o = (a == null ? void 0 : a.name) ?? r;
  return /* @__PURE__ */ p("label", { className: "flex items-center gap-3 p-3 rounded-lg border border-[var(--clique-border)] hover:bg-[var(--clique-bg-subtle)] cursor-pointer transition-colors", children: [
    /* @__PURE__ */ s(it, { checked: t, onChange: () => i(e.id), disabled: n }),
    /* @__PURE__ */ p("div", { className: "flex flex-col flex-1 min-w-0", children: [
      /* @__PURE__ */ s("span", { className: "text-sm font-medium text-[var(--clique-fg)] break-words", children: e.name || e.displayName }),
      /* @__PURE__ */ s("span", { className: "text-xs text-[var(--clique-fg-secondary)] break-all", children: o })
    ] }),
    e.isTrusted && /* @__PURE__ */ s("span", { className: "text-xs px-2 py-0.5 rounded bg-green-100 text-green-800", children: "Trusted" })
  ] });
}
function Lt({
  visible: e,
  onHide: t,
  clientId: n,
  onSaved: i,
  onSuccess: r,
  onError: a
}) {
  const o = Tt({
    visible: e,
    clientId: n,
    onSaved: i,
    onSuccess: r,
    onError: a,
    onHide: t
  }), d = () => o.isLoading ? /* @__PURE__ */ s(me, { message: "Loading identity providers..." }) : o.isError ? /* @__PURE__ */ s(
    pe,
    {
      error: o.error,
      resourceLabel: "identity providers",
      onRetry: o.refetch
    }
  ) : o.sortedProviders.length === 0 ? /* @__PURE__ */ s(
    Fe,
    {
      icon: "pi pi-key",
      title: "No identity providers",
      message: "No identity providers are configured for this tenant."
    }
  ) : /* @__PURE__ */ s("div", { className: "flex flex-col gap-3", children: o.sortedProviders.map((m) => /* @__PURE__ */ s(
    Ct,
    {
      provider: m,
      checked: o.selectedIds.has(m.id),
      disabled: o.isSaving,
      onToggle: o.handleToggle
    },
    m.id
  )) });
  return /* @__PURE__ */ s(
    Ce,
    {
      visible: e,
      onHide: t,
      header: "Manage Identity Providers",
      modal: !0,
      draggable: !1,
      resizable: !1,
      closable: !o.isSaving,
      closeOnEscape: !o.isSaving,
      style: { width: "32rem" },
      breakpoints: { "640px": "95vw" },
      footer: /* @__PURE__ */ p("div", { className: "flex justify-end gap-3", children: [
        /* @__PURE__ */ s(
          K,
          {
            type: "button",
            label: "Cancel",
            onClick: t,
            severity: "secondary",
            outlined: !0,
            disabled: o.isSaving
          }
        ),
        /* @__PURE__ */ s(
          K,
          {
            type: "button",
            label: "Save",
            icon: "pi pi-check",
            onClick: o.handleSave,
            raised: !0,
            loading: o.isSaving,
            disabled: !o.hasChanges || o.isLoading
          }
        )
      ] }),
      children: d()
    }
  );
}
function Nt(e) {
  const { clientId: t, onSuccess: n, onError: i } = e, [r, a] = $(!1), [o, d] = $(/* @__PURE__ */ new Set()), {
    data: m,
    isLoading: c,
    isError: l,
    error: y,
    refetch: u
  } = ke(), {
    data: L,
    isLoading: O,
    isError: V,
    error: F,
    refetch: q
  } = Oe(t), _ = _e(t), T = Re(t), N = X(
    () => new Set((L == null ? void 0 : L.map((D) => D.id)) ?? []),
    [L]
  ), A = X(() => m ? [...m].sort((D, h) => {
    const C = N.has(D.id) ? 0 : 1, z = N.has(h.id) ? 0 : 1;
    if (C !== z) return C - z;
    const R = (D.sortOrder ?? 1 / 0) - (h.sortOrder ?? 1 / 0);
    return R !== 0 ? R : (D.displayName || D.name).localeCompare(h.displayName || h.name);
  }) : [], [m, N]), j = w(() => {
    Promise.all([u(), q()]);
  }, [u, q]), P = w(
    (D, h) => {
      const C = D.name || D.displayName || "Unknown", z = h ? "remove" : "assign", R = h ? "unassigned from" : "assigned to", v = D.id;
      d((E) => new Set(E).add(v)), (h ? T : _).mutate(v, {
        onSuccess: () => {
          n == null || n(`${C} ${R} client.`), Promise.all([u(), q()]);
        },
        onError: () => {
          i == null || i(`Failed to ${z} ${C}. Please try again.`);
        },
        onSettled: () => {
          d((E) => {
            const M = new Set(E);
            return M.delete(v), M;
          });
        }
      });
    },
    [_, T, u, q, n, i]
  ), ne = c || O, J = l || V, W = y ?? F;
  return {
    allProviders: m,
    sortedProviders: A,
    assignedIds: N,
    assignedCount: N.size,
    availableCount: ((m == null ? void 0 : m.length) ?? 0) - N.size,
    isLoading: ne,
    isError: J,
    error: W,
    refetch: j,
    togglingIds: o,
    handleToggle: P,
    showDialog: r,
    setShowDialog: a
  };
}
const St = {
  "google-oauth": "Google",
  "azure-oidc": "Azure AD",
  oidc: "OpenID Connect",
  oauth2: "OAuth2",
  saml2: "SAML 2.0",
  wsfed: "WS-Federation",
  "in-common": "InCommon",
  "in-common-direct": "InCommon (Direct)",
  piv: "PIV",
  ldap: "LDAP",
  local: "Local",
  apple: "Apple"
};
function qt({
  provider: e,
  assigned: t,
  toggling: n,
  onToggle: i
}) {
  const r = St[e.type] ?? e.type, { data: a } = ze(e.issuerId), o = (a == null ? void 0 : a.name) ?? r, d = [
    "idp-card",
    t ? "idp-card--assigned" : "",
    n ? "idp-card--toggling" : ""
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ p(
    "button",
    {
      type: "button",
      onClick: () => i(e, t),
      disabled: n,
      className: d,
      children: [
        n ? /* @__PURE__ */ s(
          rt,
          {
            style: { width: "14px", height: "14px" },
            strokeWidth: "4",
            className: "shrink-0"
          }
        ) : /* @__PURE__ */ s("div", { className: `idp-dot ${t ? "idp-dot--active" : "idp-dot--available"}` }),
        /* @__PURE__ */ p("div", { className: "idp-card__content", children: [
          /* @__PURE__ */ s("span", { className: "idp-card__title", children: e.name || e.displayName }),
          /* @__PURE__ */ s("span", { className: "idp-card__subtitle", children: o })
        ] }),
        t ? /* @__PURE__ */ s("span", { className: "idp-badge idp-badge--active", children: "Active" }) : /* @__PURE__ */ s("span", { className: "idp-badge idp-badge--available", children: "Available" })
      ]
    }
  );
}
function tn({
  clientId: e,
  onSuccess: t,
  onError: n
}) {
  const i = Nt({ clientId: e, onSuccess: t, onError: n }), r = w(
    (a, o) => {
      const d = a.name || a.displayName || "Unknown", m = o ? "remove" : "assign";
      st({
        message: o ? `Are you sure you want to remove "${d}" from this client? Users will no longer be able to sign in with this provider.` : `Are you sure you want to assign "${d}" to this client? Users will be able to sign in with this provider.`,
        header: `Confirm ${m}`,
        icon: "pi pi-exclamation-triangle",
        acceptClassName: o ? "p-button-danger" : "p-button-primary",
        accept: () => i.handleToggle(a, o)
      });
    },
    [i]
  );
  return /* @__PURE__ */ p("div", { children: [
    /* @__PURE__ */ s(ot, {}),
    /* @__PURE__ */ s("div", { className: "idp-toolbar", children: /* @__PURE__ */ s(
      K,
      {
        type: "button",
        label: "Manage Providers",
        icon: "pi pi-cog",
        onClick: () => i.setShowDialog(!0),
        size: "small"
      }
    ) }),
    i.isLoading && /* @__PURE__ */ s(me, { message: "Loading identity providers..." }),
    i.isError && /* @__PURE__ */ s(
      pe,
      {
        error: i.error,
        resourceLabel: "identity providers",
        onRetry: i.refetch
      }
    ),
    !i.isLoading && !i.isError && /* @__PURE__ */ p("div", { children: [
      /* @__PURE__ */ p("div", { className: "idp-stats", children: [
        /* @__PURE__ */ p("span", { className: "idp-stat", children: [
          /* @__PURE__ */ s("span", { className: "idp-dot idp-dot--active" }),
          i.assignedCount,
          " active"
        ] }),
        /* @__PURE__ */ p("span", { className: "idp-stat", children: [
          /* @__PURE__ */ s("span", { className: "idp-dot idp-dot--available" }),
          i.availableCount,
          " available"
        ] })
      ] }),
      /* @__PURE__ */ s("div", { className: "idp-grid", children: i.sortedProviders.map((a) => /* @__PURE__ */ s(
        qt,
        {
          provider: a,
          assigned: i.assignedIds.has(a.id),
          toggling: i.togglingIds.has(a.id),
          onToggle: r
        },
        a.id
      )) }),
      i.sortedProviders.length === 0 && /* @__PURE__ */ p("div", { className: "idp-empty", children: [
        /* @__PURE__ */ s("i", { "aria-hidden": "true", className: "pi pi-key idp-empty__icon" }),
        /* @__PURE__ */ s("p", { children: "No identity providers configured for this tenant." })
      ] })
    ] }),
    /* @__PURE__ */ s(
      Lt,
      {
        visible: i.showDialog,
        onHide: () => i.setShowDialog(!1),
        clientId: e,
        onSuccess: t,
        onError: n
      }
    )
  ] });
}
export {
  ft as ExpansionVariables,
  Qe as HtmlCodeEditor,
  Lt as IdentityProviderAssignmentDialog,
  tn as IdentityProviderDashboard,
  bt as LoginTemplateDialog,
  It as LoginTemplateHistoryDialog,
  Zt as LoginTemplateList,
  en as LoginTemplateSelector,
  Ue as TemplatePreviewDialog,
  ee as clientLoginPageKeys,
  ye as clientLoginPagesApi,
  te as htmlTemplatesApi,
  de as identityProviderKeys,
  ve as identityProvidersApi,
  Be as issuerKeys,
  rn as issuersApi,
  k as loginTemplateKeys,
  Z as tenantLoginPageKeys,
  ge as tenantLoginPagesApi,
  _e as useAssignIdentityProviderToClient,
  Oe as useClientIdentityProviders,
  Yt as useClientLoginPage,
  Gt as useClientLoginPages,
  gt as useCreateClientLoginPage,
  ct as useCreateLoginTemplate,
  Jt as useCreateTenantLoginPage,
  Vt as useDefaultLoginTemplate,
  mt as useDeleteLoginTemplate,
  Tt as useIdpAssignmentController,
  Nt as useIdpDashboardController,
  ze as useIssuer,
  Ht as useLoginTemplate,
  vt as useLoginTemplateDialogController,
  dt as useLoginTemplateHistory,
  ht as useLoginTemplateListController,
  wt as useLoginTemplateSelectorController,
  lt as useLoginTemplateVariables,
  Le as useLoginTemplates,
  pt as useRevertLoginTemplate,
  ke as useTenantIdentityProviders,
  jt as useTenantLoginPage,
  Me as useTenantLoginPages,
  Re as useUnassignIdentityProviderFromClient,
  yt as useUpdateClientLoginPage,
  Xt as useUpdateDraftClientLoginPage,
  Ke as useUpdateDraftLoginPage,
  ut as useUpdateLoginTemplate,
  Wt as useUpdateTenantLoginPage
};
//# sourceMappingURL=index.js.map
